import React from "react";
import { Tabs } from "@opendate-app/setlist";

const styles = {
  gallery: {
    display: "flex",
    gap: 32,
    marginTop: 24,
  },
  sidebar: {
    width: 240,
    flexShrink: 0,
  },
  sidebarTitle: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "var(--sl-text-tertiary)",
    marginBottom: 8,
  },
  grid: {
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: 16,
    alignContent: "start",
  },
  card: (selected) => ({
    padding: 0,
    textAlign: "left",
    border: `1px solid ${selected ? "var(--sl-border-brand)" : "var(--sl-border-secondary)"}`,
    boxShadow: selected ? "0 0 0 1px var(--sl-border-brand)" : "none",
    borderRadius: "var(--sl-radius-xl)",
    background: "var(--sl-bg-primary)",
    overflow: "hidden",
    cursor: "pointer",
  }),
  thumbnail: {
    position: "relative",
    height: 180,
    overflow: "hidden",
    background: "var(--sl-bg-secondary)",
    borderBottom: "1px solid var(--sl-border-secondary)",
  },
  details: {
    padding: "12px 16px",
  },
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cardName: {
    fontSize: 14,
    fontWeight: 600,
    color: "var(--sl-text-primary)",
  },
  description: {
    fontSize: 12,
    lineHeight: "18px",
    color: "var(--sl-text-tertiary)",
  },
};

export const BlueprintGallery = ({ caption, ariaLabel, tabs, value, onChange, children }) => (
  <div style={styles.gallery}>
    <nav style={styles.sidebar} aria-label={ariaLabel}>
      <div style={styles.sidebarTitle}>{caption}</div>
      <Tabs
        orientation="vertical"
        variant="button-minimal"
        size="sm"
        collapseBelow={0}
        value={value}
        onChange={onChange}
        items={tabs}
      />
    </nav>
    <div style={styles.grid}>{children}</div>
  </div>
);

export const BlueprintCard = ({ name, description, selected, onSelect, children, ...rest }) => (
  <button type="button" style={styles.card(selected)} onClick={onSelect} {...rest}>
    <div style={styles.thumbnail}>{children}</div>
    <div style={styles.details}>
      <div style={{ ...styles.cardName, ...styles.ellipsis }}>{name}</div>
      {description && <div style={{ ...styles.description, ...styles.ellipsis }}>{description}</div>}
    </div>
  </button>
);
